var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0800781 7.99983C0.0800781 8.39747 0.402478 8.71979 0.800078 8.71979H13.4618L9.09097 13.0906C8.80979 13.3718 8.80979 13.8277 9.09097 14.1088C9.37214 14.39 9.82802 14.39 10.1092 14.1088L15.1434 9.07467C15.737 8.48107 15.737 7.51862 15.1434 6.92503L10.1092 1.89081C9.82802 1.60964 9.37214 1.60964 9.09097 1.89081C8.80979 2.17199 8.80979 2.62787 9.09097 2.90905L13.4618 7.27983H0.800078C0.402478 7.27983 0.0800781 7.60218 0.0800781 7.99983Z",
    fill: "#212737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.12b7ec4c78eef1cab3ab345ed4f171ae.svg";
export { ForwardRef as ReactComponent };